import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'modal.mistake.title',
        defaultMessage: 'See a mistake in your {fieldName}?',
    },
    subtitle: {
        id: 'modal.mistake.subtitle',
        defaultMessage:
            "This value comes from your identity verification. If it's incorrect, our support team can help fix it.",
    },
    cancel: {
        id: 'modal.mistake.cancel',
        defaultMessage: 'Cancel',
    },
    contact: {
        id: 'modal.mistake.contact',
        defaultMessage: 'Get help',
    },
})
